<div class="header-badge" [class.disabled]="isDisabled">
  <span>{{ text }}</span>
</div>
